<!--选择仓库-->
<template>
  <el-dialog title="仓库选择"
             :visible.sync="dialogFormVisible"
             :custom-class="dialogClass"
             center
             :close-on-click-modal="false"
             :append-to-body="true" @close="afterCloseDialog">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-col :span="12" style="line-height: 50px">
      <p v-show="uname"><span>操作人：</span>{{uname}}<span>正在操作</span><span @click="unlock"
                                                                         style="color: blue;cursor: pointer;">&nbsp;解除锁定</span>
      </p>
        <p v-if="linecredit&&linecredit!=0" :style="{color:linecredit<0?'red':'blue'}" style="margin-left: 20px;font-weight:bold;float:left ">
          <span>信用额度：</span>{{linecredit}}
        </p>
      </el-col>
      <el-col :span="12"  style="line-height: 50px">
         <span style="line-height: 18px">{{controlData.customerserial}}
        {{controlData.customername}}</span>
      </el-col>
      <el-col :span="12" v-if="supplierData.length>0">
        <el-form-item label="供应商：" :label-width="formLabelWidth" :required="true">
          <el-select v-model="controlData.pcustomerserial" placeholder="请选择" @change="changeSupply" style="width: 140px">
            <el-option
              v-for="item in supplierData"
              :key="item.customerserial"
              :label="item.deptname"
              :value="item.customerserial">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
      <el-form-item label="发货仓库：" :label-width="formLabelWidth" :required="true">
        <el-select v-model="form.cangkucode" placeholder="请选择" @change="changecangku" style="width: 130px">
          <el-option
            v-for="item in jxcstoreData"
            :key="item.cangkucode"
            :label="item.cangkuname"
            :value="item.cangkucode">
          </el-option>
        </el-select>
        <el-select v-model="form.warehouse" size="mini" style="width: 100px" v-if="warehouse.length>1&&form.cangkucode&&!this.isjiagong" @change="changewarehose">
          <el-option v-for="item in warehouse" :key="item.serial" :label="item.name" :value="item.serial">
          </el-option>
        </el-select>
        <span style="padding-left: 30px;color: red" v-if="needbuystore>0">缺货：{{needbuystore}}</span>
      </el-form-item>
      </el-col>
      <el-col :span="12">
      <el-form-item label="供应商单号：" :label-width="formLabelWidth">
        <el-input v-model="form.tracknum" placeholder="请填写供应商单号"
                  onfocus="this.select()"
                  style="width: 140px"></el-input>
        <!--<span style="color:red;font-weight:bold;" v-if="controlData.isjiaji==1">加急</span>&nbsp;&nbsp;<span-->
        <!--style="color:red;font-weight:bold; " v-if="controlData.isjiaji==1">期望时间：</span>{{controlData.wantarrivaltime}}-->
      </el-form-item>
      </el-col>
      <el-col :span="24" v-if="usebomSeed.length>0">
        <el-form-item label="白包商品：" :label-width="formLabelWidth">
          <el-table
            :data="usebomSeed"
            size="mini" border
            style="width: 100%;">
            <el-table-column label="产品编码" align="left" header-align="center" :show-overflow-tooltip="true" width="100">
              <template slot-scope="scope">
                {{ scope.row.seedcode }}
              </template>
            </el-table-column>
            <el-table-column label="产品名称" align="left" header-align="center" width="300" >
              <template slot-scope="scope">
                {{ scope.row.seedname }}
              </template>
            </el-table-column>
            <el-table-column label="白包" align="left" header-align="center">
              <template slot-scope="scope">
                <el-radio v-model="scope.row.checkcode" v-for="item in scope.row.bom" @change="bindStore"
                          :key="item.seedcode" :label="item.seedcode">{{item.seedname}}</el-radio>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-col>
      <el-col :span="24">
      <el-form-item label="" label-width="0" v-if="!isjiagong">
        <el-table
          :data="tableData" v-if="BindOver&&intelligentstore"
          :height="tableHeight(182)"
          size="mini"
          border :row-class-name="tableRowClassName"
          style="width: 100%;">
          <el-table-column label="R/L" align="center" header-align="center" width="50">
            <template slot-scope="scope">
              {{ getRL(scope.row.formproperty) }}
            </template>
          </el-table-column>
          <el-table-column label="产品编码" align="left" header-align="center" :show-overflow-tooltip="true" width="100">
            <template slot-scope="scope">
              {{ scope.row.seedcode }}
            </template>
          </el-table-column>
          <el-table-column label="产品名称" align="left" header-align="center" width="200" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.seedname }}
            </template>
          </el-table-column>
          <el-table-column label="规格" align="left" header-align="center" width="130">
            <template slot-scope="scope">
              <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 96%;height:24px;"
                   :title="scope.row.newpackagesize">{{ scope.row.newpackagesize }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="参数" align="center" header-align="center" width="80">
            <template slot-scope="scope">
              {{ getParam(scope.row.formproperty) }}
            </template>
          </el-table-column>
          <el-table-column label="订单数量" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.totalnumber}}
            </template>
          </el-table-column>
          <el-table-column label="库存" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.subtractnum}}
            </template>
          </el-table-column>
          <el-table-column label="待发货" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.deliverying}}
            </template>
          </el-table-column>
          <!--<el-table-column label="调拨中" align="right" header-align="center" width="70">-->
            <!--<template slot-scope="scope">-->
              <!--{{scope.row.transfernum}}-->
            <!--</template>-->
          <!--</el-table-column>-->
          <el-table-column label="可用库存" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.canuse}}
            </template>
          </el-table-column>
          <el-table-column label="缺" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.stock}}
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      </el-col>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <template v-if="returnorderpercent&&returnorderpercent>0">
        退货率：<span v-if="returnorderpercent>=10" style="color: red;font-size: x-large"><b>{{returnorderpercent}}</b></span>
        <span v-else style="color: black;font-size:x-large"><b>{{returnorderpercent}}</b></span>%
      </template>
      <el-button @click="dialogFormVisible = false;afterCloseDialog()">取 消</el-button>
      <el-button type="primary" class="qrbtn" @click="updatecangku" :loading="isDisable" v-if="!uname&&showbutton">确认</el-button>
      <el-button type="danger" class="qrbtn" @click="beginchaidan" :loading="isDisable" v-if="!uname&&showbutton&&showchaidan">拆单</el-button>
      <BuyfromEssilor ref="BuyfromEssilor" @afterEssilorBuy="afterEssilorBuy" :buytype="'sale'"></BuyfromEssilor>
    </div>
  </el-dialog>
</template>
<script>
  import {updatecangku, getJxcformdetailGetList, saveCstagreementData,updatejiagong,jxcstorelist,getBackpercent} from '@/api/set/csagreement';
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {getBomslist} from  '@/api/set/jxcgooddetail';
  import {getDuiZhangCus} from '@/api/voucher/accountresultbz';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {saveData, getListData, lockremove} from '@/api/set/handlelog';
  import {simulationLogin, checkModuleRight} from '@/api/login'
  import {suppliers} from '@/api/set/externaldept';
  import BuyfromEssilor from '@/components/testorder/buyagreement/BuyfromEssilor'

  export default {
    inject: ["afterCloseDialog"],
    name: "StoreEdit",
    data() {
      return {
        isDisable: false,//控制多次提交
        showbutton:false,
        caozuoname: '',
        linecredit:'',
        buyunitguid:'',
        showchaidan:false,
        totalnumber:0,
        fengongscangku:false,
        needbuystore: 0,
        dialogFormVisible: false,
        intelligentstore: true,
        dialogClass: '',
        showtitle: '',
        GetCount:0,
        BindOver: true,
        jxcstoreData: [],
        thirdstore:false,
        returnorderpercent:'',
        packagesizelist:[],
        hd_status: null,
        unitguid: '',
        erpserial: "",
        status: "",
        isjiagong: '',
        tableData: [],
        controlData: [],
        supplierData:[],
        ssotoken:'',
        usebomSeed:[],
        bomSet:[],
        warehouse:[],
        bn: '',
        form: {
          cangkucode: null,
          cangkuname: null,
          tracknum: '',
          warehouse: '',
          warehousename: ''
        },
        issimpleupdate: 0,
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          cangkucode: [
            {required: true, message: '请选择仓库', trigger: 'change'},
          ],
        },
        lock: false,//锁定订单
        uname: '',//正在操作的人
        userInfoModel: {},//当前缓存
      }
    },
    methods: {
      getParam(formpro) {
        var val = '';
        if (formpro) {
          try {
            var json = JSON.parse(formpro)[0];
            if (json.ADD) {
              val += 'ADD:' + json.ADD;
            }
            if (json['通道']) {
              val += '  通道:' + json['通道'];
            }
          } catch (e) {

          }
        }
        return val;
      },
      getRL(formpro) {
        if (formpro) {
          try {
            var json = JSON.parse(formpro)[0].type;
            if (json)
              return json;
          } catch (e) {

          }
        }
        return '';
      },
      //解除锁定
      unlock() {
        var casestepname = ''
        if (this.isjiagong) {
          casestepname = '操作通知加工';
        } else {
          casestepname = '操作通知仓库';
        }
        lockremove({
          erpserial: this.erpserial
        }).then(response => {
          if (response.data.code == 0) {
            this.lock = true
            this.uname = ''
            //锁定功能(控制发起采购按钮)
            this.handlelog(casestepname);
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })

          }
        })
      },
      //处理日志
      handlelog(casestepname) {
        if(this.issimpleupdate == 1)
          return;

        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1
        if (!casestepname) {
          handlelog.insub=1;
          handlelog.totalnumber=this.totalnumber;
          if (this.isjiagong) {
            handlelog.casestepname = '通知加工'
            handlelog.remark = '通知' + this.form.cangkuname + '加工'
          } else if (this.status == '650') {
            handlelog.casestepname = '退货审核通过'
            handlelog.remark = '等待仓库收货'
          } else {
            handlelog.casestepname = '通知仓库'
            handlelog.remark = '通知' + this.form.cangkuname + '发货'
          }
        } else {//锁定功能进这里
          handlelog.isopen = 0
          handlelog.casestepname = casestepname
        }
        saveData(handlelog).then(response => {})
      },
      tableRowClassName({row, rowIndex}) {
        if (row.canuse < row.totalnumber) {
          return 'danger-row';
        }
        return '';
      },
      beginchaidan() {
        var arr = []
        for (let i in this.tableData) {
          var row = this.tableData[i];
          arr.push({unitguid: row.unitguid, totalnumber: row.totalnumber, stock: row.stock});
        }
        this.dialogFormVisible=false;
        this.$emit('showChaiDan', {unitguid: this.unitguid}, arr);
      },
      updatecangku() {
        //缺货提示
        if (this.needbuystore > 0) {
          this.$confirm('部分商品库存不足，建议采购！是否继续通知仓库？', '库存不足', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.proceedUpdatecangku();
          }).catch(() => {
            this.isDisable = false
          });
        } else {
          this.proceedUpdatecangku();
        }
      },
      proceedUpdatecangku() {
        this.ssotoken = '';
        if (this.supplierData.length > 0) {
          if (!this.controlData.pcustomerserial) {
            this.$message({
              message: '供应商必选！',
              type: 'error'
            })
            this.isDisable = false
            return
          }

          for (let i in this.supplierData) {
            if (this.supplierData[i].customerserial == this.controlData.pcustomerserial) {
              if (this.supplierData[i].ssocode.indexOf('supplier') > -1)
                this.ssotoken = this.supplierData[i].ssocode;
              break;
            }
          }
        }

        if (!this.ssotoken && JSON.parse(localStorage.getItem("hpapi_parames")).other.oddrequired == 'true') {
          if (!this.form.tracknum) {
            this.$message({
              message: '请输入供应商单号',
              type: 'error'
            })
            this.isDisable = false
            return
          }
        }

        if (!this.form.cangkucode) {
          this.$message({
            message: "请选择仓库",
            type: 'error'
          })
          this.isDisable = false
          return;
        }

        this.bomSet = [];//选择的白包商品
        var bomseedcode = ''
        if (this.usebomSeed.length > 0) {
          for (let i in this.usebomSeed) {
            if (!this.usebomSeed[i].checkcode) {
              this.$message({
                message: "请选择关联的白包商品",
                type: 'error'
              })
              this.isDisable = false
              return;
            }

            var bomseedname = '';
            for (let j in this.usebomSeed[i].bom) {
              if (this.usebomSeed[i].bom[j].seedcode == this.usebomSeed[i].checkcode)
                bomseedname = this.usebomSeed[i].bom[j].seedname;
            }
            this.bomSet.push({
              seedcode: this.usebomSeed[i].seedcode, seedname: this.usebomSeed[i].seedname
              , bomseedcode: this.usebomSeed[i].checkcode, bomseedname: bomseedname
            });
            bomseedcode = this.usebomSeed[i].checkcode;
          }
        }

        this.$refs.form1.validate((valid) => {
          if (valid) {
            if (this.ssotoken) {
              var ssobuydetail = [];
              for (let i in this.tableData) {
                var packagesize = this.tableData[i].packagesize ? JSON.parse(this.tableData[i].packagesize) : {
                  "X": "",
                  "Y": ""
                };
                var formproperty = JSON.parse(this.tableData[i].formproperty)[0]

                var arr = {
                  "Number": this.tableData[i].totalnumber,
                  "X": packagesize.X,
                  "Y": packagesize.Y,
                  "seedcode": this.tableData[i].seedcode
                };
                if (packagesize.type)
                  arr.type = packagesize.type;
                for (let key in formproperty) {
                  if (key == 'X' && key == 'Y')
                    continue;
                  if (key == 'type' && arr.type) {
                    continue;
                  }
                  arr[key] = formproperty[key];
                }
                ssobuydetail.push(arr);
              }
              this.controlData.cangkuname = this.form.cangkuname
              this.controlData.cangkucode = this.form.cangkucode
              this.$refs.BuyfromEssilor.show(this.ssotoken, JSON.stringify(ssobuydetail), this.controlData, bomseedcode);
            } else
              this.postcangku(null);
          }
        })
      },
      afterEssilorBuy(buyInfo) {
        this.postcangku(buyInfo);
      },
      postcangku(supplydetail) {
        if (this.isjiagong) {//修改供应商仓库的时候使用;通知加工
          updatejiagong({
            unitguid: this.unitguid,
            cangkucode: this.form.cangkucode,
            cangkuname: this.form.cangkuname,
            status: 300,
            tracknum: this.form.tracknum.trim(),
            invoicesource: 1
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.handlelog();
              this.$emit('bindGrid');
              this.$emit('print');
              this.dialogFormVisible = false;

            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
              this.isDisable = false
            }
          })
        } else if (this.issimpleupdate == 1) {//修改仓库的时候使用
          var cstdata = {
            unitguid: this.unitguid,
            cangkucode: this.form.cangkucode,
            cangkuname: this.form.cangkuname,
            warehouse: this.form.warehouse,
            warehousename: this.form.warehousename,
          }
          saveCstagreementData(cstdata).then(response => {
            if (response.data.code == 0) {
              if (this.buyunitguid) {
                cstdata.unitguid = this.buyunitguid;
                saveCstagreementData(cstdata).then(buyresponse => {});//同步修改采购单
              }
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.dialogFormVisible = false;
              this.$emit('afertupdatecangku', this.form.cangkucode, this.form.cangkuname, this.form.warehouse, this.form.warehousename);
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
              this.isDisable = false
            }
          })
        } else {
          updatecangku({
            erpserial: this.erpserial,
            unitguid: this.unitguid,
            cangkucode: this.form.cangkucode,
            cangkuname: this.form.cangkuname,
            warehouse:this.form.warehouse,
            warehousename:this.form.warehousename,
            tracknum: this.form.tracknum.trim(),
            status: this.status,
            pcustomerserial: this.controlData.pcustomerserial,
            pcustomer: this.controlData.pcustomer,
            invoicesource: this.bn,
            supplydetail: supplydetail,
            weidianids: this.bomSet.length > 0 ? JSON.stringify(this.bomSet) : null//存关联商品信息
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              if (this.status != 500)
                this.handlelog();
              this.$emit('bindGrid');
              this.$emit('print');
              this.dialogFormVisible = false;
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
              this.isDisable = false
            }
          })
        }
      },
      initData(item, isjiagong, dialogCl, issimpleupdate) {
        var obj = this
        this.initForm()
        if (item.biaoji == "store") {
          this.bn = 2
        }
        if(item.buyunitguid){
          this.buyunitguid=item.buyunitguid;
        }
        this.showbutton=false
        this.linecredit='';
        this.dialogClass = (dialogCl || 'mini-dialog');
        this.unitguid = item.unitguid
        this.erpserial = item.erpserial
        this.status = item.status
        this.thirdstore=item.thirdstore;
        this.dialogFormVisible = true;
        this.issimpleupdate = issimpleupdate
        if (isjiagong && isjiagong == 1) {
          this.isjiagong = true
        } else {
          this.isjiagong = false
        }
        this.usebomSeed=[]
        if(item.status==650) {
          getBackpercent({erpserial: this.erpserial}).then(resBack => {
            if (resBack.data && resBack.data.backpercent) {
              this.returnorderpercent = resBack.data.backpercent;
            }
          });
        }
        if(item.jxcformdetailDOList) {
          for (var i in item.jxcformdetailDOList) {
            this.totalnumber += Math.abs(item.jxcformdetailDOList[i].totalnumber);
          }
        }
        cusandptbyind({thirdstore:item.thirdstore?2:0}).then(response => {
          this.jxcstoreData = response.data.obj
          if (this.jxcstoreData && this.jxcstoreData.length > 0) {



            if (item.cangkucode && item.cangkuname) {
              for (let i in this.jxcstoreData) {
                if (this.jxcstoreData[i].cangkucode == item.cangkucode) {
                  this.form.cangkucode = item.cangkucode;
                  this.form.cangkuname = item.cangkuname;
                  this.setwarehouse(this.jxcstoreData[i]);
                  break
                }
              }
            }else{
              if(this.fengongscangku) {
                var initCangKu = item.applybydserial;
                for (let i in this.jxcstoreData) {
                  if (this.jxcstoreData[i].independentserial == initCangKu) {
                    this.form.cangkucode = this.jxcstoreData[i].cangkucode;
                    this.form.cangkuname = this.jxcstoreData[i].cangkuname;
                    this.setwarehouse(this.jxcstoreData[i]);
                    break;
                  }
                }
              }
            }
            if (!this.form.cangkucode) {
              this.form.cangkucode = this.jxcstoreData[0].cangkucode;
              this.form.cangkuname = this.jxcstoreData[0].cangkuname;
              this.setwarehouse(this.jxcstoreData[0]);
            }
            if (this.issimpleupdate == 1 && item.warehouse) {
              this.form.warehouse = item.warehouse;
              this.form.warehousename = item.warehousename;
            }
            //////////////////////////////

            if (this.isjiagong || !this.intelligentstore || this.dialogClass == 'mini-dialog') {
              this.BindOver = false;
              this.showbutton = true;
              return;
            }
            var bomseedStr = '';
            for (var i in item.jxcformdetailDOList) {
              if (item.jxcformdetailDOList[i].usebom == 1) {
                if ((';' + bomseedStr).indexOf((';' + item.jxcformdetailDOList[i].seedcode + ';')) == -1) {
                  bomseedStr += item.jxcformdetailDOList[i].seedcode + ';';
                  this.usebomSeed.push({
                    seedcode: item.jxcformdetailDOList[i].seedcode,
                    seedname: item.jxcformdetailDOList[i].seedname,
                    checkcode: '',
                    bom: []
                  });
                }
              }
            }

            //////////////取订单明细///////////////
            getJxcformdetailGetList({
              erpserial: this.erpserial,
            }).then(resOrder => {
              this.tableData = resOrder.data.obj;
              this.controlData = resOrder.data.cstagreementDO;
              suppliers({seedcodes: '["' + resOrder.data.obj[0].seedcode + '"]'}).then(suppOrder => {//取供应商,配置了依视路对接的必选供应商
                this.supplierData = suppOrder.data.obj;
                var hasDuijie = false;
                for (let i in this.supplierData) {
                  if (this.supplierData[i].ssocode && this.supplierData[i].ssocode.indexOf('supplier') > -1)
                    hasDuijie = true;
                }
                if (!hasDuijie)
                  this.supplierData = []
                else if (this.supplierData.length == 1) {
                  this.controlData.pcustomer = this.supplierData[0].deptname;
                  this.controlData.pcustomerserial = this.supplierData[0].customerserial
                }

                this.initwarehouse();

                if (this.status != 500) {
                  if (bomseedStr) {//对应的白包商品
                    getBomslist({seedcode: bomseedStr}).then(response => {
                      if (response.data.code == 0) {
                        for (let i in response.data.obj) {
                          for (var j in this.usebomSeed) {
                            if (this.usebomSeed[j].seedcode == response.data.obj[i].seedcode) {
                              this.usebomSeed[j].bom.push({
                                seedcode: response.data.obj[i].bomseedcode,
                                seedname: response.data.obj[i].seedname,
                              });
                            }
                          }
                        }

                        for (var j in this.usebomSeed) {
                          if (this.usebomSeed[j].bom.length == 1) {
                            this.usebomSeed[j].checkcode = this.usebomSeed[j].bom[0].seedcode;
                          }
                        }
                      }

                      this.bindStore();
                    });
                  }
                  else
                    this.bindStore();
                }
                else {
                  this.BindOver = false;
                  this.showbutton = true;
                }
              });

            });
          }
        })

        if (this.status != 200) {
          this.lock = true;
          return;
        }
        //查询订单是否有人正在操作
        getListData({
          erpserial: this.erpserial,
        }).then(response => {
          this.lock = true;
          if (response.data.obj.length > 0) {
            //发起采购、通知仓库按钮会同时出现，只要有一个在操作需要锁定订单
            //当前登陆人与日志表uname不一致时锁定采购订单
            for (let i = 0; i < response.data.obj.length; i++) {
              if (response.data.obj[i].casestepname == '操作通知仓库' || response.data.obj[i].casestepname == '申请采购' || response.data.obj[i].casestepname == '操作通知加工') {
                this.lock = false;
                if (response.data.obj[i].uname && this.userInfoModel.uname != response.data.obj[i].uname) {
                  this.uname = response.data.obj[i].uname;
                  break;
                }
              }
            }

            //信用额度
            if(item.paymethod.indexOf('按合同结算')>-1) {
              getDuiZhangCus({customerserial: item.customerserial}).then(resCredit => {
                if (resCredit.data.code == 0) {
                  var useMoney = parseFloat(resCredit.data.obj) + parseFloat(item.htje|0)+parseFloat(item.expressfee|0);//已使用金额
                  this.linecredit=(parseFloat(resCredit.data.linecredit)-useMoney).toFixed(2);
                  if (useMoney > parseFloat(resCredit.data.linecredit)&&!(resCredit.data.settingmoney==99)) {//超额 不给发货
                    this.isDisable = true;
                    checkModuleRight({name: 'linecreditNobuy'}).then(reponse => {
                      if (reponse.data.code == 0) {
                        this.isDisable = false;
                      }
                    });
                  }
                }
              })
            }

          }
          if (this.lock) {
            //锁定功能(控制发起采购按钮)
            if (isjiagong && isjiagong == 1) {
              this.handlelog('操作通知加工');
            } else if (isjiagong && isjiagong == -1) {
              this.handlelog('操作通知仓库');
            }
          }
        })
      },
      bindStore() {
        // var SeedCodes = ';';
        this.packagesizelist=[];
        for (let i in this.tableData) {
          this.tableData[i].subtractnum = 0;
          this.tableData[i].deliverying = 0;
          this.tableData[i].transfernum = 0;
          this.tableData[i].canuse = 0;
          this.packagesizelist.push(this.tableData[i].packagesize);
        }
        this.needbuystore = 0;
        this.BindOver = false;
        this.GetCount = 0;
        var SeedCodes = ';';
        this.showchaidan=false;
        for (let i in this.tableData) {
          var seedC = this.tableData[i]['seedcode'];
          if (SeedCodes.indexOf(';' + seedC + ';') == -1) {
            SeedCodes += seedC + ';';
            this.GetCount += 1;
          } else {
            continue;
          }
          this.checkStore(seedC);
          // }
        }
      },
      checkStore(seedC) {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        var subSeedcode = '';
        for (var j in this.usebomSeed) {
          if (this.usebomSeed[j].seedcode == seedC) {
            subSeedcode = this.usebomSeed[j].checkcode ? this.usebomSeed[j].checkcode : '';
            break;
          }
        }
        getGoodsListWithStoreDetail({
          //seedcode: seedC + (subSeedcode ? (',' + subSeedcode) : ''),//产品分类（单选）
          seedcode: subSeedcode ? subSeedcode : seedC,//产品分类（单选）
          cangkucode: this.form.cangkucode,//选择的仓库（单选）
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1,
          nolimit:1,
          notransfernum:1,
          nobuynum:1,
          warehouse: this.form.warehouse,
          packagesizelist:JSON.stringify(this.packagesizelist)
        }).then(resStore => {
          var storeData = resStore.data.obj//库存片
          for (let orderIndex in this.tableData) {
            var orderRow = this.tableData[orderIndex];
            if (orderRow.seedcode == seedC) {
              var needBuyS = orderRow.totalnumber;

              var bb_storeRowSelect = null;
              //先合并白包商品库存
              if(seedC!=subSeedcode) {
                for (let storeIndex in storeData) {
                  var storeRow = storeData[storeIndex];
                  if (subSeedcode == storeRow.seedcode && (orderRow.packagesize == undefined || orderRow.packagesize == storeRow.packagesize)) {
                    if (!storeRow.hasHeBing) {
                      storeRow.hasHeBing = true;
                      bb_storeRowSelect = storeRow;
                    }
                    break;
                  }
                }
              }

              var storeRowSelect = null;
              for (let storeIndex in storeData) {
                var storeRow = storeData[storeIndex];
                if (seedC == storeRow.seedcode && (orderRow.packagesize == undefined || orderRow.packagesize == storeRow.packagesize)) {
                  storeRowSelect = storeRow;
                  break;
                }
              }
              if (storeRowSelect == null && bb_storeRowSelect != null) {
                bb_storeRowSelect.seedcode = seedC;
                storeRowSelect = bb_storeRowSelect;
              } else if (storeRowSelect == null && bb_storeRowSelect == null) {
                storeRowSelect = {
                  subtractnum: 0,
                  deliverying: 0,
                  transfernum: 0,
                  seedcode: seedC,
                  packagesize: orderRow.packagesize
                };
                storeData.push(storeRowSelect);
              } else { //先合并白包商品库存
                if (bb_storeRowSelect) {
                  storeRowSelect.subtractnum += bb_storeRowSelect.subtractnum;
                  storeRowSelect.deliverying += bb_storeRowSelect.deliverying;
                  storeRowSelect.transfernum += bb_storeRowSelect.transfernum;
                }
              }

              orderRow.subtractnum = storeRowSelect.subtractnum;
              orderRow.deliverying = storeRowSelect.deliverying;
              orderRow.transfernum = storeRowSelect.transfernum;
              orderRow.canuse = storeRowSelect.subtractnum - storeRowSelect.deliverying ;//+ storeRowSelect.transfernum;//库存数量
              orderRow.stock=0;
              if (orderRow.canuse < orderRow.totalnumber) {//订单需要的数量 超过 库存数量
                needBuyS = orderRow.totalnumber - (orderRow.canuse > 0 ? orderRow.canuse : 0);//需要补货的数量
                orderRow.stock=needBuyS;
              } else {
                needBuyS = 0;
                //storeRowSelect.subtractnum = storeRowSelect.subtractnum - orderRow.totalnumber;//需要扣掉已使用的
              }
              storeRowSelect.deliverying += orderRow.totalnumber;

              this.needbuystore += needBuyS;
              this.tableData[orderIndex] = orderRow;
            }
          }

          this.GetCount -= 1;
          if (this.GetCount == 0) {
            this.BindOver = true;
            this.showbutton = !(this.thirdstore && this.needbuystore > 0);
            this.showchaidan=this.totalnumber>this.needbuystore&&this.needbuystore>0;
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      changeSupply(val) {
        for (let i in this.supplierData) {
          if (this.supplierData[i].customerserial == val) {
            this.controlData.pcustomer = this.supplierData[i].deptname;
            var wh = this.form.warehouse;
            this.initwarehouse();
            if (this.intelligentstore && wh != this.form.warehouse)
              this.bindStore();
            break;
          }
        }
      },
      changecangku(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.form.cangkuname = this.jxcstoreData[i].cangkuname;
            this.setwarehouse(this.jxcstoreData[i]);
            this.initwarehouse();
          }
        }
        if (this.intelligentstore)
          this.bindStore();
      },
      changewarehose(val) {
        for (let i in this.warehouse) {
          if (this.warehouse[i].serial == val) {
            this.form.warehousename = this.warehouse[i].name;
            if (this.intelligentstore)
              this.bindStore();
            break;
          }
        }
      },
      setwarehouse(store){
        this.warehouse=[]
        this.form.warehouse='';
        this.form.warehousename='';
        if(store.warehouse){
          this.warehouse=JSON.parse(store.warehouse);
          if(this.warehouse.length<=1){
            this.warehouse=[];
          }else{//默认第一个库位
            this.form.warehouse=this.warehouse[0].serial;
            this.form.warehousename=this.warehouse[0].name;
          }
        }
      },
      initwarehouse(){
        for (let j in this.warehouse) {
          var cus=this.warehouse[j].cus;
          for(let row in cus){
            if(cus[row]==this.controlData.pcustomerserial){//默认库位
              this.form.warehouse = this.warehouse[j].serial;
              this.form.warehousename = this.warehouse[j].name;
              break;
            }
          }
        }
      },
      initForm() {
        this.showchaidan=false;
        this.form.tracknum = ''
        this.buyunitguid=''
        this.tableData = []
        this.form.cangkucode = null
        this.form.cangkuname = null
        this.dialogClass = 'mini-dialog';
        this.erpserial = ""
        this.caozuoname = ''
        this.returnorderpercent=''
        this.form.unitguid = ""
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.uname = ''
        this.issimpleupdate = 0
        this.totalnumber=0;
        this.supplierData=[]
        this.isjiagong = false;
        this.isDisable = false
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.intelligentstore=true;
      checkModuleRight({name: 'fengongscangku'}).then(reponse => {
        this.fengongscangku = reponse.data.code == 0;
      });
      // checkModuleRight({name: 'intelligentstore'}).then(reponse => {
      //   this.intelligentstore = reponse.data.code == 0;
      // });
    },
    components: {BuyfromEssilor}
  }
</script>


<style scoped>
  .Hid {
    display: none;
  }

  .ddinfo {
    border-collapse: collapse;
    width: 100%;
    margin-top: 12px;

  }

  .ddinfo td {
    font-size: 14px;
    text-align: center;
    border: 1px solid #E0DFDF;
  }
</style>

<style>
  .el-table .danger-row {
    background: #F56C6C;
  }
</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/StoreEdit.vue